<script setup lang="ts">
import { Toaster as VueSonnerToaster } from "vue-sonner";

import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
</script>

<template>
  <VueSonnerToaster position="top-right" close-button>
    <template #info-icon>
      <SvgIcon name="filled/info" class="toast-icon toast-icon--info" />
    </template>
    <template #success-icon>
      <SvgIcon name="sticker/checkmark" class="toast-icon toast-icon--success" />
    </template>
    <template #error-icon>
      <SvgIcon name="message/error" class="toast-icon toast-icon--error" />
    </template>
  </VueSonnerToaster>
</template>

<style lang="scss">
@use "@/styles/mixins/shadow";
@use "@/styles/mixins/typography";
@use "@/styles/variables/colors";

/* Sonner toast overrides: match Figma design */
[data-sonner-toast][data-styled="true"] {
  @include shadow.default;
  @include typography.medium("semi-bold");

  width: 450px;
  min-height: 64px;
  padding: 16px 16px 16px 12px;
  gap: 12px;
  border: none;
  border-radius: 8px;
  background: colors.$background-ui;
  color: colors.$text;
}

[data-sonner-toast][data-styled="true"] [data-icon] {
  width: 24px;
  height: 24px;
  margin: 0;
}

.toast-icon {
  width: 24px;
  height: 24px;

  &--info {
    color: colors.$main;
  }

  &--success {
    color: colors.$primary-success;
  }

  &--error {
    color: colors.$destructive;
  }
}

[data-sonner-toast][data-styled="true"] [data-button] {
  @include typography.medium("medium");

  height: 32px;
  padding: 8px;
  border-radius: 4px;
  background: colors.$main;
  color: colors.$text-inverse;
}
</style>
